<template>
  <toggle-token-group
    :tokens="tokens"
    :maxColumns="2"
    :status="status"
    :helperText="helperText"
    legend="What ages do you have experience with?"
    @input="updateTokenState"
  />
</template>

<script lang="ts">
import ToggleTokenGroup from '@/components/toggle_token/ToggleTokenGroup.vue';
import { childCareAgeGroupsToggleTokenOptions } from './__types__/AgeTypes';
import helperStatus from '@/helpers/status';
import focusOnElement from '@/helpers/focusHelper';
import waitForElm from '@/helpers/waitForElm';

export default {
  name: 'AgeGroupsStep',
  components: {
    ToggleTokenGroup,
  },
  data() {
    return {
      status: helperStatus.Neutral,
    };
  },
  computed: {
    helperText(): String | null {
      if (this.status === helperStatus.Error) {
        return 'Selecting at least one age is required.';
      }
      return null;
    },
    ageGroups: {
      get() {
        return this.$store.getters.getFormField('ageGroups');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'ageGroups', value: newValue });
      },
    },
    tokens(): Object[] {
      return childCareAgeGroupsToggleTokenOptions.map((option) => ({
        ...option,
        value: this.ageGroups.includes(option.type),
      }));
    },
  },
  methods: {
    focusElement() {
      if (this.status === helperStatus.Error) {
        waitForElm('#toggle-token-group-helper').then(() => {
          focusOnElement(document.querySelector('#toggle-token-group-helper') as HTMLElement);
        });
      } else {
        focusOnElement(document.querySelector('.toggle-token-group') as HTMLElement);
      }
    },
    validate() {
      if (!this.ageGroups || this.ageGroups.length === 0) {
        this.status = helperStatus.Error;
        return false;
      }
      return true;
    },
    updateTokenState(newTokens) {
      const newValue = [] as string[];
      newTokens.forEach((option) => {
        if (option.value) newValue.push(option.type);
      });
      if (this.status === helperStatus.Error && newValue.length) {
        this.status = helperStatus.Neutral;
      }
      this.ageGroups = newValue;
    },
  },
};
</script>
